import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import {DvrRecordStatus} from '../../../services/api/dvr/dvr.model';

enum Colors {
  red = '#ED323A',
  yellow = '#DEC24D',
  green = '#3BC458',
  gray = '#A0A0A0'
}

@Component({
  selector: 'app-dvr-status',
  templateUrl: './dvr-status.component.html',
  styleUrls: ['./dvr-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DvrStatusComponent {
  @Input() status: DvrRecordStatus;
  @Input() progress: number | null = null;

  public colors: Record<DvrRecordStatus, Colors> = {
    failed: Colors.red,
    waiting: Colors.yellow,
    starting: Colors.yellow,
    recording: Colors.red,
    stopping: Colors.yellow,
    completed: Colors.green,
    deleting: Colors.yellow,
    initialization: Colors.yellow,
    deleted: Colors.gray
  };

  public tooltips: Record<DvrRecordStatus, string> = {
    failed: 'Record failed',
    waiting: 'Waiting for incoming stream',
    starting: 'Recording Starting',
    recording: 'Recording',
    stopping: 'Completing',
    completed: 'Completed',
    deleting: 'Record Deleting',
    initialization: 'Record Initialization',
    deleted: 'Record Deleted'
  };

  public getTextTooltip(status: DvrRecordStatus): string {
    if (status === 'stopping') {
      if (this.progress === null) {
        return 'Completing: 0%';
      }

      return `Completing: ${this.progress}%`;
    }

    return this.tooltips[status];
  }
}
